import type { ContentSnippetApiData } from '@packages/cms-components/src/modules/PromotionBanner/types';
import { useI18n } from '@packages/shared';
import useSWR from 'swr';

export const useNlSheetTexts = (
  fallbackNlSheetTexts: ContentSnippetApiData | undefined = undefined,
) => {
  const { language, defaultLanguage } = useI18n();
  const finalLanguage = language || defaultLanguage || 'de';
  const nlSheetTextsCacheKey = `nlSheetData-${finalLanguage}`;
  const { data } = useSWR<ContentSnippetApiData>(nlSheetTextsCacheKey, {
    fallbackData: fallbackNlSheetTexts,
  });
  const nlTexts =
    data?.data?.[0] && data.data[0].type === 'content_snippet_bundled--nl_sheet' && data.data[0];
  return {
    nlTexts,
    endpoint: nlSheetTextsCacheKey,
  };
};
